import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

export const PARAMETRAGE = {
  title: 'Paramétrage',
  racine: 'Accueil',
  actions: {
    search: 'Rechercher',
  },
  categorie: {
    affixe2: 'Affixe2.0',
    gestCom: 'Gestion commerciale',
    comptabilite: 'Comptabilité',
    achat: 'Achat',
    patrimoine: 'Patrimoine',
    baux: 'Baux',
    logistique: 'Logistique',
    presse: 'Presse',
    impressionAffiche: 'Impression d\'affiche',
  },
  sousCategorie: {
    typeProduit: 'Type de produit',
    regleFacturation: 'Règle de facturation',
    regimeTva: 'Régime de TVA',
    societes: 'Gestion des sociétés',
    edition: 'Gestion des éditions',
    collaborateurs: 'Gestion des collaborateurs',
    ajoutCollab: 'Ajout collaborateur',
    role: 'Gestion des rôles',
    modeReglement: 'Modes de règlement',
    domiciliationBancaire: 'Domiciliation bancaire',
    natureProduit: 'Nature de produit',
    schemaComptable: 'Schéma comptable',
    commentaire: 'Commentaire pré-paramétré',
    contratNature: 'Nature de bail',
    contratSignataire: 'Signataire',
    format: 'Format',
    typeReseau: 'Type réseau',
    secteurActivite: 'Secteur activité',
    civilite: 'Civilité',
    dispositifSupport: 'Dispositif support',
    dispositifType: 'Dispositif type',
    materielLocalisation: 'Localisation matériel',
    materielAngleVision: 'Angle vision matériel',
    materielFormat: 'Format matériel',
    materielType: 'Type matériel',
    faceMotifNonCom: 'Motif face non commercialisable',
    motifBlocage: 'Motif blocage paiement',
    typePointVente: 'Type point de vente',
    profilTiers: 'Profil de tiers',
    relanceOption: 'Relance d\'option',
    delaiReglement: 'Délai règlement',
    typeTaxationTlpe: 'Type taxation tlpe',
    accessoire: 'Accessoire',
    compteAnalytique: 'Compte analytique',
    categorieGroupeProduitDeductible: 'Catégorie groupe produit déductible',
    libelle_remise: 'Libellé remise personnalisé',
    indexation: 'Gestion inflation',
    typeOt: 'Types OT technique',
    couleurEncart: 'Couleur encart',
    emplacementPresse: 'Emplacement',
    periodicite: 'Périodicité',
    surface: 'Surface',
    modeDistribution: 'Mode de distribution',
    typeFormatPresse: 'Type format presse',
    typeEvenementSponsoring: 'Type d\'événement sponsoring',
    typeContact: 'Type contact',
    typeEvenement: 'Evénement',
    motifAnnulationReglement: 'Motif annulation règlement',
    editionBat: 'Edition BAT',
    mailBat: 'Mail BAT',
    etatSuiviAdministratif: 'Etat suivi administratif',
    indiceEtValeur: 'Indice et valeur',
    marque: 'Marque',
    tag: 'Tags',
    nomenclatureType: 'Nomenclature',
    secteur: 'Secteur',
    pays: 'Pays',
    fonctionContact: 'Fonction contact',
    natureSupportAffiche: 'Nature de support d\'affiche',
    competenceFournisseur: 'Compétence fournisseur',
    formatAffiche: 'Format d\'affiche',
    service: 'Service',
  },
  tab: {
    libelle: 'Libellé',
    code: 'Code',
  },
  liste: {
    'commun/SecteurActivite': 'Liste des secteurs d\'activités',
    'commun/Civilite': 'Liste des civilités',
    'patri/MaterielAngleVision': 'Liste des angles vision du matériel',
    'gescom/CategorieGroupeProduitDeductible': 'Liste des catégories de groupe produit déductible ',
    'gescom/MotifAnnulationReglement': 'Liste des motifs d\'annulation de règlement',
    'gescom/TypeReseau': 'Liste des types de réseau',
    'gescom/Format': 'Liste des formats',
    'commun/TypePointVente': 'Liste des types de point de vente',
    'commun/ProfilTiers': 'Liste des profils de tiers',
    'commun/FaceMotifNonCom': 'Liste des motifs face non commercialisable',
    'patri/DispositifSupport': 'Liste des supports de dispositif',
    'commun/EtatSuiviAdministratif': 'Liste état suivi administratif',
    'commun/Marque': 'Liste des marques',
    'commun/FonctionContact': 'Liste des fonctions de contact',
    'commun/NatureSupportAffiche': 'Liste des natures de support d\'affiche',
    'commun/CompetenceFournisseur': 'Liste des compétences fournisseur',
    'commun/TypeProduit': 'Liste types produit',
    'gescom/TypeEvenementSponsoring': 'Liste des types événements sponsoring',
    'gescom/ModeDistribution': 'Liste des modes de distribution',
    'gescom/EmplacementPresse': 'Liste des emplacements presse',
    'gescom/CouleurEncart': 'Liste des couleurs d\'encarts',
    'patri/MaterielLocalisation': 'Liste des localisations du matériel',
    'commun/MotifBlocage': 'Liste des motifs de blocage de paiement',
    'gescom/TypeEvenementPM': 'Liste des événements',
    'patri/ContratSignataire': 'Listes des signataires',
  },
  addLibelle: {
    'commun/SecteurActivite': 'Ajouter un secteur d\'activité',
    'commun/Civilite': 'Ajouter une civilité',
    'patri/MaterielAngleVision': 'Ajouter un angle vision du matériel',
    'gescom/CategorieGroupeProduitDeductible': 'Ajouter une catégorie de groupe produit déductible ',
    'gescom/MotifAnnulationReglement': 'Ajouter un motif d\'annulation de règlement',
    'gescom/TypeReseau': 'Ajouter un type réseau',
    'gescom/Format': 'Ajouter un format',
    'commun/TypePointVente': 'Ajouter un type de point de vente',
    'commun/ProfilTiers': 'Ajouter un profil de tiers',
    'commun/FaceMotifNonCom': 'Ajouter un motif de face non commercialisable',
    'patri/DispositifSupport': 'Ajouter un support de dispositif',
    'commun/EtatSuiviAdministratif': 'Ajouter un état de suivi administratif',
    'commun/Marque': 'Ajouter une marque',
    'commun/FonctionContact': 'Ajouter une fonction de contact',
    'commun/NatureSupportAffiche': 'Ajouter une nature de support d\'affiche',
    'commun/CompetenceFournisseur': 'Ajouter une compétence fournisseur',
    'commun/TypeProduit': 'Ajouter un type produit',
    'gescom/TypeEvenementSponsoring': 'Ajouter un type événement sponsoring',
    'gescom/ModeDistribution': 'Ajouter un mode de distribution',
    'gescom/EmplacementPresse': 'Ajouter un emplacement presse',
    'gescom/CouleurEncart': 'Ajouter une couleur d\'encart',
    'patri/MaterielLocalisation': 'Ajouter une localisation du matériel',
    'commun/MotifBlocage': 'Ajouter un motif blocage paiement',
    'gescom/TypeEvenementPM': 'Ajouter un événement',
    'patri/ContratSignataire': 'Ajouter un signataire',
  },
  breadcrumb: {
    'commun/SecteurActivite': 'Liste secteur d\'activité',
    'commun/Civilite': 'Liste civilité',
    'patri/MaterielAngleVision': 'Liste angle vision du matériel',
    'gescom/CategorieGroupeProduitDeductible': 'Liste catégories groupe produit déductible ',
    'gescom/MotifAnnulationReglement': 'Liste des motifs d\'annulation de règlement',
    'gescom/TypeReseau': 'Liste type réseau',
    'gescom/Format': 'Liste format',
    'commun/TypePointVente': 'Liste des types de point de vente',
    'commun/ProfilTiers': 'Liste des profils de tiers',
    'commun/FaceMotifNonCom': 'Liste motif face non commercialisable',
    'patri/DispositifSupport': 'Liste support de dispositif',
    'commun/EtatSuiviAdministratif': 'Liste état suivi administratif',
    'commun/Marque': 'Liste marque',
    'commun/FonctionContact': 'Liste des fonctions de contact',
    'commun/NatureSupportAffiche': 'Liste des natures de support d\'affiche',
    'commun/CompetenceFournisseur': 'Liste des compétences fournisseur',
    'commun/TypeProduit': 'Liste types produit',
    'gescom/TypeEvenementSponsoring': 'Liste des types événements sponsoring',
    'gescom/ModeDistribution': 'Liste des modes de distribution',
    'gescom/EmplacementPresse': 'Liste des emplacements presse',
    'gescom/CouleurEncart': 'Liste des couleurs d\'encarts',
    'patri/MaterielLocalisation': 'Liste localisation du matériel',
    'commun/MotifBlocage': 'Liste motif blocage paiement',
    'gescom/TypeEvenementPM': 'Listes des événements',
    'patri/ContratSignataire': 'Liste des signataires',
  },
  EditLibelle: {
    'commun/SecteurActivite': 'Modifier un secteur d\'activité',
    'commun/Civilite': 'Modifier une civilité',
    'patri/MaterielAngleVision': 'Modifier un angle vision du matériel',
    'gescom/CategorieGroupeProduitDeductible': 'Modifier une catégorie de groupe produit déductible ',
    'gescom/MotifAnnulationReglement': 'Modifier un motif d\'annulation de règlement',
    'gescom/TypeReseau': 'Modifier un type réseau',
    'gescom/Format': 'Modifier un format',
    'commun/TypePointVente': 'Modifier un type de point de vente',
    'commun/ProfilTiers': 'Modifier un profil de tiers',
    'commun/FaceMotifNonCom': 'Modifier un motif de face non commercialisable',
    'patri/DispositifSupport': 'Modifier un support de dispositif',
    'commun/EtatSuiviAdministratif': 'Modifier un état de suivi administratif',
    'commun/Marque': 'Modifier une marque',
    'commun/FonctionContact': 'Modifier une fonction de contact',
    'commun/NatureSupportAffiche': 'Modifier une nature de support d\'affiche',
    'commun/CompetenceFournisseur': 'Modifier une compétence fournisseur',
    'commun/TypeProduit': 'Modifier un type produit',
    'gescom/TypeEvenementSponsoring': 'Modifier un type événement sponsoring',
    'gescom/ModeDistribution': 'Modifier un mode de distribution',
    'gescom/EmplacementPresse': 'Modifier un emplacement presse',
    'gescom/CouleurEncart': 'Modifier une couleurs d\'encart',
    'patri/MaterielLocalisation': 'Modifier une localisation du matériel',
    'commun/MotifBlocage': 'Modifier un motif blocage paiement',
    'gescom/TypeEvenementPM': 'Modifier un événement',
    'patri/ContratSignataire': 'Modifier un signataire',
  },
  successCreation: {
    'commun/SecteurActivite': 'Le secteur d\'activité a été ajouté avec succès.',
    'commun/Civilite': 'La civilité a été ajoutée avec succès.',
    'patri/MaterielAngleVision': 'L\'angle vision du matériel a été ajouté avec succès.',
    'gescom/CategorieGroupeProduitDeductible': 'La catégorie de groupe produit déductible a été ajoutée avec succès.',
    'gescom/MotifAnnulationReglement': 'Le motif a été ajouté avec succès.',
    'gescom/TypeReseau': 'Le type réseau a été ajouté avec succès.',
    'gescom/Format': 'Le format a été ajouté avec succès.',
    'commun/TypePointVente': 'Le type de point de vente a été ajouté avec succès.',
    'commun/ProfilTiers': 'Le profil de tiers a été ajouté avec succès.',
    'commun/FaceMotifNonCom': 'Le motif de face non commercialisable a été ajouté avec succès.',
    'patri/DispositifSupport': 'Le dispositif support a été ajouté avec succès.',
    'commun/EtatSuiviAdministratif': 'L\'état de suivi administratif a été ajouté avec succès.',
    'commun/Marque': 'La marque a été ajoutée avec succès.',
    'commun/FonctionContact': 'La fonction de contact a été ajoutée avec succès.',
    'commun/NatureSupportAffiche': 'La nature de support d\'affiche a été ajoutée avec succès.',
    'commun/CompetenceFournisseur': 'La compétence fournisseur a été ajoutée avec succès.',
    'commun/TypeProduit': 'Le type produit a été ajoutée avec succès.',
    'gescom/TypeEvenementSponsoring': 'Le type événement sponsoring a été ajoutée avec succès. ',
    'gescom/ModeDistribution': 'Le mode de distribution a été ajoutée avec succès.',
    'gescom/EmplacementPresse': 'L\' emplacement presse a été ajoutée avec succès.',
    'gescom/CouleurEncart': 'La couleurs d\'encart a été ajoutée avec succès.',
    'patri/MaterielLocalisation': 'La localisation du matériel a été ajoutée avec succès',
    'commun/MotifBlocage': 'Le motif blocage paiement a été ajouté avec succès',
    'gescom/TypeEvenementPM': 'L\'événement a été ajouté avec succès',
    'patri/ContratSignataire': 'Le signataire a été ajouté avec succès',
  },
  successModification: {
    'commun/SecteurActivite': 'Le secteur d\'activité a été modifié avec succès.',
    'commun/Civilite': 'La civilité a été modifiée avec succès.',
    'patri/MaterielAngleVision': 'L\'angle vision du matériel a été modifié avec succès.',
    'gescom/CategorieGroupeProduitDeductible': 'La catégorie de groupe produit déductible a été modifiée avec succès.',
    'gescom/MotifAnnulationReglement': 'Le motif a été modifié avec succès.',
    'gescom/TypeReseau': 'Le type réseau a été modifié avec succès.',
    'gescom/Format': 'Le format a été modifié avec succès.',
    'commun/TypePointVente': 'Le type de point de vente a été modifié avec succès.',
    'commun/ProfilTiers': 'Le profil de tiers a été modifié avec succès.',
    'commun/FaceMotifNonCom': 'Le motif de face non commercialisable a été modifié avec succès.',
    'patri/DispositifSupport': 'Le dispositif support a été modifié avec succès.',
    'commun/EtatSuiviAdministratif': 'L\'état de suivi administratif a été modifié avec succès.',
    'commun/Marque': 'La marque a été modifiée avec succès.',
    'commun/FonctionContact': 'La fonction de contact a été modifiée avec succès.',
    'commun/NatureSupportAffiche': 'La nature de support d\'affiche a été modifiée avec succès.',
    'commun/CompetenceFournisseur': 'La compétence fournisseur a été modifiée avec succès.',
    'commun/TypeProduit': 'Le type produit a été modifiée avec succès.',
    'gescom/TypeEvenementSponsoring': 'Le type événement sponsoring a été modifié avec succès. ',
    'gescom/ModeDistribution': 'Le mode de distribution a été modifié avec succès.',
    'gescom/EmplacementPresse': 'L\' emplacement presse a été modifié avec succès.',
    'gescom/CouleurEncart': 'La couleurs d\'encart a été modifiée avec succès.',
    'patri/MaterielLocalisation': 'La localisation du matériel a été modifiée avec succès',
    'commun/MotifBlocage': 'Le motif blocage paiement a été modifié avec succès',
    'gescom/TypeEvenementPM': 'L\'événement a été modifié avec succès',
    'patri/ContratSignataire': 'Le signataire a été modifié avec succès',
  },
  tables: {
    gabed_t_dispositif: 'Dispositifs',
    gescom_t_campagne: 'Campagnes',
    commun_t_tiers_marque: 'Clients',
    gescom_t_secteur_lien: 'utilisateurs, produits ou bails',
    commun_t_tiers: 'Clients ou Fournisseurs',
  },
  generique: {
    [PARAMETRES_KEYS.categorieGroupeProduitDeductible]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver cette catégorie de groupe ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver cette catégorie de groupe ?',
        successArchiver: 'La catégorie de groupe a été archivée.',
        successDesarchiver: 'La catégorie de groupe a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer cette catégorie de groupe ?',
        successSupprimer: 'La catégorie de groupe a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.marque]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver cette marque ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver cette marque ?',
        successArchiver: 'La marque a été archivée.',
        successDesarchiver: 'La marque a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer cette marque ?',
        successSupprimer: 'La marque a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.civilite]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver cette civilité ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver cette civilité ?',
        successArchiver: 'La civilité a été archivée.',
        successDesarchiver: 'La civilité a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer cette civilité ?',
        successSupprimer: 'La civilité a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.competenceFournisseur]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver cette compétence fournisseur ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver cette compétence fournisseur ?',
        successArchiver: 'La compétence fournisseur a été archivée.',
        successDesarchiver: 'La compétence fournisseur a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer cette compétence fournisseur ?',
        successSupprimer: 'La compétence fournisseur a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.dispositifSupport]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce dispositif support ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce dispositif support ?',
        successArchiver: 'Le dispositif support a été archivé.',
        successDesarchiver: 'Le dispositif support a été désarchivé.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer ce dispositif support ?',
        successSupprimer: 'Le dispositif support a été supprimé avec succès.',
      },
    },
    [PARAMETRES_KEYS.faceMotifNonCom]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce motif non commercial ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce motif non commercial ?',
        successArchiver: 'Le motif non commercial a été archivé.',
        successDesarchiver: 'Le motif non commercial a été désarchivé.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer ce motif non commercial ?',
        successSupprimer: 'Le motif non commercial a été supprimé avec succès.',
      },
    },
    [PARAMETRES_KEYS.fonctionContact]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver cette fonction de contact ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver cette fonction de contact ?',
        successArchiver: 'La fonction de contact a été archivée.',
        successDesarchiver: 'La fonction de contact a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer cette fonction de contact ?',
        successSupprimer: 'La fonction de contact a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.format]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce format ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce format ?',
        successArchiver: 'Le format a été archivé.',
        successDesarchiver: 'Le format a été désarchivé.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer ce format ?',
        successSupprimer: 'Le format a été supprimé avec succès.',
      },
    },
    [PARAMETRES_KEYS.materielAngleVision]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver cet angle de vision du matériel ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver cet angle de vision du matériel ?',
        successArchiver: 'L\'angle de vision du matériel a été archivé.',
        successDesarchiver: 'L\'angle de vision du matériel a été désarchivé.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer cet angle de vision du matériel ?',
        successSupprimer: 'L\'angle de vision du matériel a été supprimé avec succès.',
      },
    },
    [PARAMETRES_KEYS.motifAnnulationReglement]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce motif d\'annulation de règlement ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce motif d\'annulation de règlement ?',
        successArchiver: 'Le motif d\'annulation de règlement a été archivé.',
        successDesarchiver: 'Le motif d\'annulation de règlement a été désarchivé.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer ce motif d\'annulation de règlement ?',
        successSupprimer: 'Le motif d\'annulation de règlement a été supprimé avec succès.',
      },
    },
    [PARAMETRES_KEYS.natureSupportAffiche]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver cette nature de support d\'affiche ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver cette nature de support d\'affiche ?',
        successArchiver: 'La nature de support d\'affiche a été archivée.',
        successDesarchiver: 'La nature de support d\'affiche a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer cette nature de support d\'affiche ?',
        successSupprimer: 'La nature de support d\'affiche a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.profilTiers]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce profil tiers ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce profil tiers ?',
        successArchiver: 'Le profil tiers a été archivé.',
        successDesarchiver: 'Le profil tiers a été désarchivé.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer ce profil tiers ?',
        successSupprimer: 'Le profil tiers a été supprimé avec succès.',
      },
    },
    [PARAMETRES_KEYS.secteurActivite]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce secteur d\'activité ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce secteur d\'activité ?',
        successArchiver: 'Le secteur d\'activité a été archivé.',
        successDesarchiver: 'Le secteur d\'activité a été désarchivé.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer ce secteur d\'activité ?',
        successSupprimer: 'Le secteur d\'activité a été supprimé avec succès.',
      },
    },
    [PARAMETRES_KEYS.typePointVente]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce type de point de vente ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce type de point de vente ?',
        successArchiver: 'Le type de point de vente a été archivé.',
        successDesarchiver: 'Le type de point de vente a été désarchivé.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer ce type de point de vente ?',
        successSupprimer: 'Le type de point de vente a été supprimé avec succès.',
      },
    },
    [PARAMETRES_KEYS.typeReseau]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce type de réseau ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce type de réseau ?',
        successArchiver: 'Le type de réseau a été archivé.',
        successDesarchiver: 'Le type de réseau a été désarchivé.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer ce type de réseau ?',
        successSupprimer: 'Le type de réseau a été supprimé avec succès.',
      },
    },
    [PARAMETRES_KEYS.etatSuiviAdministratif]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver cet état de suivi administratif ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver cet état de suivi administratif ?',
        successArchiver: 'L\'état de suivi administratif a été archivé.',
        successDesarchiver: 'L\'état de suivi administratif a été désarchivé.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer cet état de suivi administratif ?',
        successSupprimer: 'L\'état de suivi administratif a été supprimé avec succès.',
      },
    },
    [PARAMETRES_KEYS.typeProduit]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce type produit ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce type produit ?',
        successArchiver: 'Le type produit a été archivée.',
        successDesarchiver: 'Le type produit a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer Le type produit ?',
        successSupprimer: 'Le type produit a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.typeEvenementSponsoring]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce type événement sponsoring ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce type événement sponsoring ?',
        successArchiver: 'Le type événement sponsoring a été archivée.',
        successDesarchiver: 'Le type événement sponsoring a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer Le type événement sponsoring ?',
        successSupprimer: 'Le type événement sponsoring a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.modeDistribution]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver ce mode de distribution ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver ce mode de distribution ?',
        successArchiver: 'Le mode de distribution a été archivée.',
        successDesarchiver: 'Le mode de distribution a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer Le mode de distribution ?',
        successSupprimer: 'Le mode de distribution a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.emplacementPresse]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver L\' emplacement presse ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver L\' emplacement presse ?',
        successArchiver: 'L\' emplacement presse a été archivée.',
        successDesarchiver: 'L\' emplacement presse a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer L\' emplacement presse ?',
        successSupprimer: 'L\' emplacement presse a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.couleurEncart]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver La couleur d\'encart ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver La couleur d\'encart ?',
        successArchiver: 'La couleur d\'encart a été archivée.',
        successDesarchiver: 'La couleur d\'encart a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer La couleur d\'encart ?',
        successSupprimer: 'La couleur d\'encart a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.materielLocalisation]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver la localisation du matériel ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver la localisation du matériel ?',
        successArchiver: 'La localisation du matériel a été archivée.',
        successDesarchiver: 'La localisation du matériel a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer la localisation du matériel ?',
        successSupprimer: 'La localisation du matériel a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.motifBlocage]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver le motif blocage paiement ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver le motif blocage paiement ?',
        successArchiver: 'Le motif blocage paiement a été archivée.',
        successDesarchiver: 'Le motif blocage paiement a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer le motif blocage paiement ?',
        successSupprimer: 'Le motif blocage paiement a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.typeEvenement]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver l\'événement ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver l\'événement ?',
        successArchiver: 'L\'événement a été archivée.',
        successDesarchiver: 'L\'événement a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer l\'événement ?',
        successSupprimer: 'L\'événement a été supprimée avec succès.',
      },
    },
    [PARAMETRES_KEYS.contratSignataire]: {
      archivage: {
        archiver: 'Etes-vous sûr de vouloir archiver le signataire ?',
        desarchiver: 'Etes-vous sûr de vouloir désarchiver le signataire ?',
        successArchiver: 'Le signataire a été archivée.',
        successDesarchiver: 'Le signataire a été désarchivée.',
      },
      suppression: {
        supprimer: 'Etes-vous sûr de vouloir supprimer le signataire ?',
        successSupprimer: 'Le signataire a été supprimée avec succès.',
      },
    },
  },
};

export const ROLE = {
  title: 'Liste des rôles',
  creation: 'Créer un role',
  libelle: 'Libellé',
  description: 'Description',
  creationRole: 'Créer un rôle',
};

export const GESTION_ROLE = {
  ajout: {
    title: 'Créer un rôle',
  },
  modification: {
    title: 'Modifier rôle {role}',
  },
  visualisation: {
    title: 'Détail du rôle ',
  },
  role: 'Rôle',
  libelle: 'Libellé',
  description: 'Description',
  successCreation: 'Création du rôle réalisée avec succès',
  successModification: 'Modification du rôle réalisée avec succès',
  errorLibelle: 'Le libellé du rôle est déjà utilisé pour un autre rôle. Veuillez saisir un autre libellé.',
  errorPermissions: 'Vous devez cocher au minimum une case correspondant à un rôle.',
};

export const ROLE_MANAGER = {
  categories: {
    lieu_de_livraison: 'Lieu de livraison',
    projets: 'Projets',
    regime_tva: 'Régime de TVA',
    devis: 'Devis',
    commandes: 'Commandes',
    factures: 'Factures',
    remises_bancaires: 'Remises Bancaires',
    catalogue: 'Catalogue',
    'clients/contacts': 'Clients/contacts',
    collaborateurs: 'Collaborateurs',
    'societe/agence': 'Societes/Agences',
    domiciliation_bancaire: 'Domiciliation bancaire',
    relance: 'Relance',
    roles: 'Rôles',
    marche: 'Marché',
    type_evenement_pm: 'Evènement',
    emplacement: 'Emplacement',
    exercice_comptable: 'Exercice comptable',
    mode_reglement: 'Mode de règlement',
    schema_comptable: 'Schéma comptable',
    mois_comptable: 'Mois comptable',
    support_commercial: 'Nature de produit',
    commentaire: 'Commentaire',
    journal_ecriture: 'Journal écriture',
    lots_comptable: 'Lots',
    tournee_modele: 'Liste d\'affichage',
    afficheur: 'Afficheur',
    demande: 'Demande',
    affectation: 'Affectation',
    general: 'Paramétrage',
    charge_travail: 'Charge de travail',
    ordre_travail: 'Ordre de travail',
    bailleur: 'Bailleur',
    contrat: 'Bail',
    contrat_nature: 'Nature de bail',
    signataire: 'Signataire',
    plan_media: 'Plan média',
    constatation_charge: 'Constatation charge',
    echeancier_contrat: 'Echeancier contrat',
    format: 'Format',
    type_reseau: 'Type réseau',
    secteur_activite: 'Secteur activité',
    civilite: 'Civilité',
    dispositif_support: 'Dispositif support',
    dispositif_type: 'Dispositif type',
    materiel_localisation: 'Matériel localisation',
    materiel_angle_vision: 'Matériel angle vision',
    materiel_format: 'Matériel format',
    materiel_type: 'Matériel type',
    face_categorie_taxe: 'Face catégorie taxe',
    face_motif_non_com: 'Face motif non commercialisable',
    motif_blocage: 'Motif blocage',
    motif_annulation_reglement: 'Motif annulation règlement',
    lot_paiement: 'Lot de paiement',
    delai_reglement: 'Délai règlement',
    edition: 'Parmètrage édition',
    type_point_vente: 'Type point de vente',
    facture_achat: 'Factures bailleur',
    relance_option: 'Relance d\'option',
    demande_tempo: 'Demande',
    type_taxation_tlpe: 'Type taxation tlpe',
    collectivite: 'Collectivité Tlpe',
    planning: 'Planning',
    situation: 'Situation',
    confrere: 'Confrère',
    compte_analytique: 'Compte analytique',
    categorie_groupe_produit_deductible: 'Catégorie groupe produit déductible',
    libelle_remise: 'Libellé remise personnalisé',
    indexation: 'Gestion inflation',
    demande_intervention: 'Demande intervention',
    type_ot: 'Type OT technique',
    technicien: 'Technicien',
    accessoire: 'Accessoire',
    materielTlpe: 'Matériel Tlpe',
    declarationTlpe: 'Déclaration Tlpe',
    profil_tiers: 'Profil tiers',
    commande_tlpe: 'Déclaration Tlpe',
    type_produit: 'Type produit',
    regle_facturation: 'Règle de facturation',
    surface: 'Surface',
    couleur_encart: 'Couleur encart',
    emplacement_presse: 'Emplacement',
    periodicite: 'Périodicité',
    mode_distribution: 'Mode distribution',
    type_evenement_sponsoring: 'Type événenement sponsoring',
    type_format_presse: 'Type format presse',
    parution: 'Parution',
    previsionnel: 'Prévisionnel de départ',
    fournisseur_support: 'Fournisseur de support',
    type_contact: 'Type contact',
    fournisseur_materiel: 'Fournisseur matériel',
    echeance_payement: 'Echéance paiement',
    ordre_travail_audit: 'Ordre de travail audit',
    affixe_mobile_patrimoine: 'Affixe mobile patrimoine',
    retrocession: 'Rétrocession',
    operation_diverse: 'Opération diverse',
    factor: 'Factor',
    transmission: 'Transmission',
    etat_suivi_administratif: 'Etat suivi administratif',
    ecriture_comptable: 'Ecriture comptable',
    chemin_fer: 'Chemin de fer',
    demarcheur: 'Démarcheur',
    signature_electronique: 'Signature électronique',
    indice_et_valeur: 'Indice et valeur',
    marque: 'Marque',
    tag: 'Tags',
    campagne: 'Campagne',
    nomenclature_type: 'Nomenclature',
    journal_reglements: 'Journal règlements',
    journal_paiements: 'Journal paiements',
    import: 'Import de données',
    bon_stock: 'Bon d\'entrée / Bon de sortie',
    demande_impression: 'Demande d\'impression',
    secteur: 'Secteur',
    ordre_travail_expedition: 'Expédition',
    ordre_travail_impression: 'Ordre de travail impression',
    commande_achat: 'Commande achat',
    suivi_production: 'Suivi de production',
    bon_expedition: 'Bon d\'expédition',
    titre_recette: 'Titre de recette',
    paiement_recette: 'Paiement',
    lot_paiement_recette: 'Lot de paiement',
    journal_paiement_recette: 'Journal paiements',
    pays: 'Pays',
    fonction_contact: 'Fonction contact',
    sprint: 'Sprint',
    nature_support_affiche: 'Nature de support d\'affiche',
    competence_fournisseur: 'Compétence fournisseur',
    fournisseurs: 'Fournisseurs',
    format_affiche: 'Format d\'affiche',
    besoin: 'Besoin',
    service: 'Service',
    bon_reception: 'Bon de réception',
    paiements_factures: 'Paiements factures',
    journal_paiements_factures: 'Journal paiements factures',
    lot_paiements_factures: 'Lot paiements factures',
    suivi_taches_internes: 'Suivi des achats',
  },
  droits: {
    lecture: 'Lecture seule',
    maj: 'Créer/Modifier',
    supprimer: 'Archiver/Supprimer',
    exporter: 'Exporter',
    edition: 'Edition',
  },
  modules: {
    parametrage: 'Paramètrage Affixe2.0',
    bodac: 'Gestion commerciale',
    gabed: 'Patrimoine',
    comptabilite: 'Comptabilité',
    logistique: 'Logistique',
    baux: 'Baux',
    presse: 'Presse',
    achat: 'Achat',
    stock: 'Bon stock',
  },
  moduleUndefined: 'Module non définie',
  categorieUndefined: 'Catégorie non définie',
  droitUndefined: 'Droit non définie',
};
